import { CLIENT_HOST } from 'src/config-global';
import { axiosInstance, endpoints } from 'src/utils/axios';

export type WhitelabelConfig = {
  name: string;
  primaryColor: string;
  logoUrl: string;
  palette?: {
    primary: {
      main: string;
    };
  };
};

// Default config; can be swapped per deployment/tenant
let whitelabelConfig: WhitelabelConfig = {
  name: 'Supermercados Fachini',
  primaryColor: '#C5201A',
  logoUrl: '/logo/logo_fachini.png',
};

// Getter para acessar o whitelabel
export const getWhitelabel = (): WhitelabelConfig => whitelabelConfig;

// Mantém compatibilidade com código existente
export const whitelabel = new Proxy({} as WhitelabelConfig, {
  get: (target, prop) => getWhitelabel()[prop as keyof WhitelabelConfig],
});

// Função para buscar whitelabel do backend
export async function loadWhitelabel(): Promise<void> {
  try {
    const hostname = CLIENT_HOST || window.location.hostname;
    const response = await axiosInstance.get(endpoints.admin.whitelabel(hostname));
    const data = response.data.whitelabel;

    // Atualiza o whitelabel com os dados do backend
    whitelabelConfig = {
      name: data.name || whitelabelConfig.name,
      logoUrl: data.logo || whitelabelConfig.logoUrl,
      primaryColor: data.palette?.primary?.main || whitelabelConfig.primaryColor,
      palette: data.palette,
    };

    console.log('Whitelabel carregado do backend:', whitelabelConfig);
  } catch (error) {
    console.warn('Erro ao carregar whitelabel do backend, usando configuração padrão:', error);
    // Mantém a configuração padrão em caso de erro
  }
}
